import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const CategoryList = async(payload) => {
  const response= await axiosInstance.post("/admin/category-list",payload);
   return response.data;
};
export const ActiveChildCategoryList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-child-category-list",payload);
   return resposne.data
};
export const ActiveCategoryList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-category-list",payload);
   return resposne.data
};
// Create
export const AddCategory = async(payload) => {
const response= await axiosInstance.post("/admin/category-store", payload);
    return response.data;
};

// Show
export const VirwCategory =async (payload) => {
const response=await  axiosInstance.post("/admin/category-show", payload);
    return response.data;
};

// Update
export const UpdateCategory = async(payload) => {
  const response= await axiosInstance.post("/admin/category-update", payload);
    return response.data;
};

// Delete
export const DeleteCategory = async(payload) => {
  const response= await axiosInstance.post("/admin/category-delete", payload);
    return response.data;
};

// Status Change
export const CategoryChangeStatus = async(payload) => {
  const response=await axiosInstance.post("/admin/category-status-update", payload);
    return response.data;
};